export default {
    titles: {
        'action-logs': 'Logs de Atividade',
        address: 'Endereço',
        'bank-account': 'Contas bancárias',
        bills: 'Faturas',
        categories: 'Categorias',
        colors: 'Cores',
        commissions: 'Comissão',
        contacts: 'Contatos',
        contents: 'Conteúdos',
        customers: 'Clientes',
        dashboard: 'Dashboard',
        emails: 'Emails',
        leads: 'Prospects',
        modules: 'Módulos',
        reseller: 'Empresa',
        roles: 'Perfis de usuários',
        users: 'Usuários',
        integrations: 'Integrações',
    },
    names: {
        index: 'Listar',
        store: 'Adicionar',
        update: 'Atualizar',
        show: 'Exibir',
        delete: 'Remover',
        'create-customer': 'Gerar cliente',
        cancel: 'Cancelar',
    },
}
